import React, { useState, useEffect } from "react"
import _get from "lodash/get"
import { isTablet } from "react-device-detect"
import { NumericFormat } from "react-number-format"

import { getAttributeValue, getPDPUrl, getUserPersona } from "@/utils/helper"
import CONSTANTS, { SWATCH_NA } from "@/constants/index"
import { pushAnalyticsData } from "@/components/ProductDetail/v3/PDPRequiredItemModal/PDPRequiredItemModalAnalytics"

import Checkbox from "@/components/core/Checkbox/Checkbox"
import ColorSwatch from "@/components/core/ColorSwatch/ColorSwatch"

import MissingImage from "@/public/images/image-missing.png"

const PDPRequiredItem = props => {
  const {
    item = {},
    addItemsData = [],
    productInfo = {},
    staticTexts = {},
    colorId = "",
    cart = {},
    locale = "",
    currencyCode = "",
    backorder = "",
    currencySign = "",
    updateItems = () => {},
    lwProdData = {},
  } = props

  const [pdpUrl, setPdpUrl] = useState("")
  const [isChecked, setIsChecked] = useState(false)
  const [selectedSkuItem, setSelectedSkuItem] = useState(
    item?.masterVariant?.sku
  )
  const persona = getUserPersona()
  const isMobile = window.innerWidth <= 480

  const requiredProductsData = []
  let colorsDataMaster = []
  const colorsDataVariants = []
  let imagesDataMaster = []
  const imagesDataVariants = []
  let priceOfMaster = []
  const priceOfVariants = []
  let category = ""
  let slug = ""
  let customerFacingSKUMaster = []
  const customerFacingSKUVariant = []

  if (item) {
    let product = {}
    const masterVariant = _get(item, "masterVariant", [])
    const variants = _get(item, "variants", [])
    const masterVariantSku = _get(masterVariant, "sku", "")
    slug = _get(item, 'slug["en-IN"]', "")

    const Color_SKU_Details_s =
      lwProdData["Color.SKU.Details_ss"]
        ?.find(item => item.includes(masterVariantSku))
        ?.split("|") ?? {}
    const productImage_labelWithUrl_s =
      lwProdData["productImage.labelWithUrl_ss"]
        ?.find(item => item.includes(masterVariantSku))
        ?.split("|") ?? {}
    const productImage = productImage_labelWithUrl_s
      ? productImage_labelWithUrl_s[productImage_labelWithUrl_s?.length - 1]
      : ""
    const SKUColorFinishName = Color_SKU_Details_s?.[0]
    const SKUColorSwatchFilename = Color_SKU_Details_s?.[1]
    const CustomerFacingSKU =
      Color_SKU_Details_s?.[Color_SKU_Details_s?.length - 1]
    product.skuid = selectedSkuItem
    product.masterVariantSku = masterVariantSku
    let masterAttributes = _get(masterVariant, "attributes", [])
    customerFacingSKUMaster = [
      {
        id: masterVariantSku,
        CustomerFacingSKU,
      },
    ]
    const masterColorName = SKUColorFinishName ?? ""
    const masterColorFiles = SKUColorSwatchFilename ?? ""
    product.brandName = lwProdData?.ProductBrandNameDisplay_s
    product.productName = lwProdData?.productName_s
    product.productDescription = _get(
      masterVariant.attributes.find(
        attr => attr.name === "ProductDescriptionProductShort"
      ),
      `value`,
      ""
    )
    imagesDataMaster = [
      {
        id: masterVariantSku,
        image: productImage ? productImage : MissingImage,
      },
    ]

    category = getAttributeValue(masterAttributes, "ProductLocalCategory")

    priceOfMaster = [
      {
        id: masterVariantSku,
        price: (
          Number(
            _get(
              masterVariant.prices.find(
                item =>
                  item?.value?.currencyCode === currencyCode &&
                  item?.customerGroup?.obj?.key === persona
              ),
              "value.centAmount",
              0
            )
          ) / 100
        ).toFixed(2),
        discountedPrice: (
          Number(
            _get(
              masterVariant.prices.find(
                item =>
                  item?.value?.currencyCode === currencyCode &&
                  item?.customerGroup?.obj?.key === persona
              ),
              "discounted.value.centAmount",
              0
            )
          ) / 100
        ).toFixed(2),
        discountPercent:
          Number(
            _get(
              masterVariant.prices.find(
                item => item?.value?.currencyCode === currencyCode
              ),
              "discounted.discount.obj.value.permyriad",
              0
            )
          ) / 100,
        discountType: _get(
          masterVariant.prices.find(
            item => item?.value?.currencyCode === currencyCode
          ),
          "discounted.discount.obj.value.type",
          ""
        ),
      },
    ]
    if (
      !masterVariant.prices.find(
        item =>
          item?.value?.currencyCode === currencyCode &&
          item?.customerGroup?.obj?.key === persona
      )
    ) {
      priceOfMaster[0].price = (
        Number(
          _get(
            masterVariant.prices.find(
              item => item?.value?.currencyCode === currencyCode
            ),
            "value.centAmount",
            0
          )
        ) / 100
      ).toFixed(2)
    }
    const cartMasterVar =
      cart?.lineItems?.find(item => item?.variant.sku === masterVariantSku) ??
      {}
    if (cartMasterVar?.discountedPrice) {
      priceOfMaster[0].discountedPrice = (
        Number(_get(cartMasterVar.discountedPrice, "value.centAmount", 0)) / 100
      ).toFixed(2)
      priceOfMaster[0].discountType = _get(
        cartMasterVar.discountedPrice,
        "includedDiscounts[0].discount.obj.value.type",
        ""
      )
      priceOfMaster[0].discountPercent =
        priceOfMaster[0].discountType === "absolute"
          ? Number(
              _get(
                cartMasterVar.discountedPrice,
                "includedDiscounts[0].discount.obj.value.money[0].centAmount",
                0
              )
            ) / 100
          : Number(
              _get(
                cartMasterVar.discountedPrice,
                "includedDiscounts[0].discount.obj.value.permyriad",
                0
              )
            ) / 100
    }

    let OutOfStockMaster = false

    // const channels = Object.values(
    //   _get(masterVariant.availability, "channels", {})
    // )
    // if (channels.length > 0) {
    //   const availableQtyMaster = _get(channels[0], "availableQuantity", 0)
    //   OutOfStockMaster = availableQtyMaster > 0 ? false : true
    // } else {
    //   OutOfStockMaster = true
    // }
    const getDiscontinuedValue = _get(
      masterAttributes.find(attr => attr.name === "RegionDiscontinuedDate"),
      "value",
      ""
    )
    const discontinuedMasterVariant =
      Date.parse(getDiscontinuedValue) < Date.now()

    colorsDataMaster = [
      {
        id: masterVariantSku,
        name: `product-color-${colorId}`,
        value: masterVariantSku,
        label: masterColorName,
        colorUrl: CONSTANTS.COLOR_FILE_URL + masterColorFiles,
        checked: masterVariantSku === selectedSkuItem ? true : false,
        isOutOfStock: OutOfStockMaster,
        isDiscontinued: discontinuedMasterVariant,
        notApplicable:
          masterColorFiles.toLowerCase() === SWATCH_NA.toLowerCase(),
      },
    ]

    variants.forEach((variant, i) => {
      const variantAttributes = _get(variant, "attributes", [])
      const variantSku = _get(variant, "sku", "")
      const Color_SKU_Details_s =
        lwProdData["Color.SKU.Details_ss"]
          ?.find(item => item.includes(variantSku))
          ?.split("|") ?? []
      const productImage =
        lwProdData["Color.ANY.Details_ss"]
          ?.find(item => item.includes(variantSku))
          ?.split("|") ?? []
      const colorName = Color_SKU_Details_s[0] ?? ""
      const colorFiles = Color_SKU_Details_s[1] ?? ""
      const getDiscontinuedValue = _get(
        variantAttributes.find(attr => attr.name === "RegionDiscontinuedDate"),
        "value",
        ""
      )
      const isDiscontinuedVariant =
        Date.parse(getDiscontinuedValue) < Date.now()
      let OutOfStockVariant = false
      // const channels = Object.values(_get(variant, "availability.channels", {}))
      // if (channels.length > 0) {
      //   const availableQtyvariants = _get(channels[0], "availableQuantity", 0)
      //   OutOfStockVariant = availableQtyvariants > 0 ? false : true
      // }
      const isImgVariant = variantSku.startsWith("IMGV")
      customerFacingSKUVariant[i] = {
        id: variantSku,
        CustomerFacingSKU: _get(
          variantAttributes.find(attr => attr.name === "CustomerFacingSKU"),
          "value",
          ""
        ),
      }
      colorsDataVariants[i] = {
        id: variantSku,
        name: `product-color-${colorId}`,
        value: variantSku,
        label: colorName,
        colorUrl: CONSTANTS.COLOR_FILE_URL + colorFiles,
        checked: variantSku === selectedSkuItem ? true : false,
        isOutOfStock: OutOfStockVariant,
        isDiscontinued: isDiscontinuedVariant || isImgVariant,
        notApplicable: false,
      }
      imagesDataVariants[i] = {
        id: variantSku,
        image: productImage.length ? productImage.pop() : MissingImage,
      }
      priceOfVariants[i] = {
        id: variantSku,
        price: (
          Number(
            _get(
              variant.prices.find(
                item =>
                  item?.value?.currencyCode === currencyCode &&
                  item?.customerGroup?.obj?.key === persona
              ),
              "value.centAmount",
              0
            )
          ) / 100
        ).toFixed(2),
        discountedPrice: (
          Number(
            _get(
              variant.prices.find(
                item =>
                  item?.value?.currencyCode === currencyCode &&
                  item?.customerGroup?.obj?.key === persona
              ),
              "discounted.value.centAmount",
              0
            )
          ) / 100
        ).toFixed(2),
        discountPercent:
          Number(
            _get(
              variant.prices.find(
                item => item?.value?.currencyCode === currencyCode
              ),
              "discounted.discount.obj.value.permyriad",
              0
            )
          ) / 100,
        discountType: _get(
          variant.prices.find(
            item => item?.value?.currencyCode === currencyCode
          ),
          "discounted.discount.obj.value.type",
          ""
        ),
      }
      if (
        !variant.prices.find(
          item =>
            item?.value?.currencyCode === currencyCode &&
            item?.customerGroup?.obj?.key === persona
        )
      ) {
        priceOfVariants[i].price = (
          Number(
            _get(
              variant.prices.find(
                item => item?.value?.currencyCode === currencyCode
              ),
              "value.centAmount",
              0
            )
          ) / 100
        ).toFixed(2)
      }
      const cartItem =
        cart?.lineItems?.find(item => item?.variant?.sku === variantSku) ?? {}
      if (cartItem?.discountedPrice) {
        priceOfVariants[i].discountedPrice = (
          Number(_get(cartItem.discountedPrice, "value.centAmount", 0)) / 100
        ).toFixed(2)
        priceOfVariants[i].discountType = _get(
          cartItem.discountedPrice,
          "includedDiscounts[0].discount.obj.value.type",
          ""
        )
        priceOfVariants[i].discountPercent =
          priceOfVariants[i].discountType === "absolute"
            ? Number(
                _get(
                  cartItem.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.money[0].centAmount",
                  0
                )
              ) / 100
            : Number(
                _get(
                  cartItem.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.permyriad",
                  0
                )
              ) / 100
      }
    })
    product.customerFacingSKU = [
      ...customerFacingSKUMaster,
      ...customerFacingSKUVariant,
    ]
    product.priceData = [...priceOfMaster, ...priceOfVariants]
    product.imagesData = [...imagesDataMaster, ...imagesDataVariants]
    product.colorsData = [...colorsDataMaster, ...colorsDataVariants]
    product.backorder = backorder
    product.inRiverId = lwProdData?.productInRiverId_s

    requiredProductsData.push(product)
  }

  useEffect(() => {
    const selectedVariant =
      addItemsData &&
      addItemsData.filter(
        list => list?.masterVariantSku === item?.masterVariant?.sku
      )
    const selectedSku =
      (selectedVariant && selectedVariant[0]?.skuid) ?? item?.masterVariant?.sku
    setSelectedSkuItem(selectedSku)
    setIsChecked(
      Boolean(
        addItemsData && addItemsData.find(list => list?.skuid === selectedSku)
      )
    )
  }, [])

  useEffect(() => {
    setIsChecked(
      Boolean(
        addItemsData &&
          addItemsData.find(list => list.skuid === selectedSkuItem)
      )
    )
  }, [addItemsData])

  useEffect(() => {
    if (category && slug) {
      getPDPUrl(category, slug).then(url => {
        setPdpUrl(url)
      })
    }
  }, [category, slug])

  const getSelectedSku = sku => {
    setSelectedSkuItem(sku)
    setIsChecked(
      Boolean(addItemsData && addItemsData.find(list => list.skuid === sku))
    )
  }

  const getPrice = (sku, type) => {
    return _get(
      requiredProductsData[0].priceData.find(item => item?.id === sku),
      type,
      0
    )
  }

  const isItemOutOfStock = backorder
    ? false
    : _get(
        requiredProductsData[0].colorsData.find(
          item => item?.id === selectedSkuItem
        ),
        "isOutOfStock",
        ""
      )

  const getEventInfo = (type, needJSON = false, link) => {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const pagetitle = page?.category?.pageType

    const eventInfo = {
      eventAction: `${pagetitle}:select a product required for installation:${type}`,
      eventName: `${pagetitle}:select a product required for installation:${type}`,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: type,
      internalLinkPosition: "items required for install",
      internalLinkType: `${pagetitle}:select a product required for installation:${type}`,
      internalLinkZoneName: `${pagetitle}:select a product required for installation`,
      internalLinkURL: link
        ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
        : "n/a",
      clickInternalLinks: "true",
    }
    if (needJSON) {
      return eventInfo
    }
    return JSON.stringify(eventInfo)
  }

  const colorswatchClickHandler = id => {
    getSelectedSku(id)
    pushAnalyticsData("color selection", productInfo)
  }

  return (
    <div className="line-item">
      <div className="line-item__image">
        <div className="product-tile__image">
          <div>
            <img
              alt=""
              src={_get(
                requiredProductsData[0].imagesData.find(
                  item => item?.id === selectedSkuItem
                ),
                "image",
                ""
              )}
              width={"120px"}
              height={"120px"}
            />
          </div>
        </div>
      </div>

      <div className="line-item__header">
        <div className="title-and-description">
          <p className="must-have">{props.staticTexts.mustItemCTA}</p>
          <div className="brand-name">
            {requiredProductsData[0].productName}
          </div>
          <div className="item-description">
            {requiredProductsData[0].productDescription}
          </div>
        </div>

        <div className="line-item__sku">
          {!isMobile ? (
            <div className="sku-id">{`K-${selectedSkuItem}`}</div>
          ) : (
            ""
          )}
          {isMobile ? (
            <div className="line-item__include--mobile">
              {!isItemOutOfStock && (
                <div>
                  <Checkbox
                    className="include-text"
                    value={""}
                    checked={isChecked}
                    onChange={e =>
                      updateItems(e.target.checked, requiredProductsData[0])
                    }
                  />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>

        {!isMobile ? (
          <div className="line-item__price--desktop">
            <div className="price">
              <div className="list-item__price">
                <NumericFormat
                  value={
                    getPrice(selectedSkuItem, "discountedPrice") > 0
                      ? getPrice(selectedSkuItem, "discountedPrice")
                      : getPrice(selectedSkuItem, "price")
                  }
                  displayType="text"
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </div>
              {getPrice(selectedSkuItem, "discountedPrice") > 0 && (
                <div className="list-item__discounted">
                  <span className="list-item__percent-off">
                    {getPrice(selectedSkuItem, "discountType") === "absolute"
                      ? `${currencySign}  ${getPrice(
                          selectedSkuItem,
                          "discountPercent"
                        )}`
                      : `${getPrice(selectedSkuItem, "discountPercent")}% ${
                          staticTexts.percentOff
                        }`}
                  </span>
                  <NumericFormat
                    value={getPrice(selectedSkuItem, "price")}
                    displayType="text"
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </div>
              )}
            </div>
            {!isItemOutOfStock && (
              <div>
                <Checkbox
                  checked={isChecked}
                  onChange={e =>
                    updateItems(e.target.checked, requiredProductsData[0])
                  }
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="line-item__info">
        {isMobile && !isTablet ? (
          <div className="sku-id">
            {_get(
              requiredProductsData[0].customerFacingSKU.find(
                item => item?.id === selectedSkuItem
              ),
              "id",
              ""
            )}
          </div>
        ) : (
          ""
        )}

        {isMobile ? (
          <div className="line-item__price--mobile">
            <div className="price">
              <div className="price_item">
                <NumericFormat
                  value={
                    getPrice(selectedSkuItem, "discountedPrice") > 0
                      ? getPrice(selectedSkuItem, "discountedPrice")
                      : getPrice(selectedSkuItem, "price")
                  }
                  displayType="text"
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </div>
              {getPrice(selectedSkuItem, "discountedPrice") > 0 && (
                <div className="discount-price">
                  <NumericFormat
                    value={getPrice(selectedSkuItem, "price")}
                    displayType="text"
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                  <span className="discount-percent-off">
                    {getPrice(selectedSkuItem, "discountType") === "absolute"
                      ? currencySign +
                        getPrice(selectedSkuItem, "discountPercent")
                      : getPrice(selectedSkuItem, "discountPercent") + "%"}{" "}
                    {staticTexts.percentOff}
                  </span>
                </div>
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="item-color">
          {requiredProductsData[0].colorsData &&
            requiredProductsData[0].colorsData.filter(
              col => !col.notApplicable && !col.isDiscontinued
            ).length > 0 && (
              <div className="color-section">
                <div className="color-finish">{staticTexts.colorOrFinish}</div>
                <div className="color-value">
                  {_get(
                    requiredProductsData[0].colorsData.find(
                      item => item?.id === selectedSkuItem
                    ),
                    "label",
                    ""
                  )}
                </div>
              </div>
            )}
          <div className="item-color-swatches">
            {requiredProductsData[0].colorsData &&
              requiredProductsData[0].colorsData
                .filter(col => !col.notApplicable && !col.isDiscontinued)
                .map((color, i) => (
                  <ColorSwatch
                    type="selector"
                    id={color.id}
                    name={color.name}
                    value={color.value}
                    label={color.label}
                    colorUrl={color.colorUrl}
                    checked={color.checked ? true : false}
                    onClick={id => colorswatchClickHandler(id)}
                    key={i}
                  />
                ))}
          </div>
          {isItemOutOfStock && (
            <div className="out-of-stock-section --desktop">
              <span className="out-of-stock-msg">
                {staticTexts.outOfStockErr}
              </span>
              <div className="back-in-stock">
                <a
                  className="gbh-data-layer"
                  data-gbh-data-layer={getEventInfo(
                    staticTexts.backInStock.toLowerCase(),
                    false,
                    pdpUrl?.trim().toLowerCase()
                  )}
                  data-gbh-data-layer-custom={productInfo}
                  href={pdpUrl}
                >
                  {staticTexts.backInStock}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>

      {!isMobile ? (
        <div className="line-item__include--mobile">
          {!isItemOutOfStock && (
            <div>
              <Checkbox
                className="include-text"
                value={staticTexts.includeTextCTA}
                checked={isChecked}
                onChange={e =>
                  updateItems(e.target.checked, requiredProductsData[0])
                }
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {!isMobile ? (
        <div className="line-item__price--mobile">
          <div className="price">
            <div className="price_item">
              <NumericFormat
                value={
                  getPrice(selectedSkuItem, "discountedPrice") > 0
                    ? getPrice(selectedSkuItem, "discountedPrice")
                    : getPrice(selectedSkuItem, "price")
                }
                displayType="text"
                thousandSeparator={true}
                prefix={currencySign}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </div>
            {getPrice(selectedSkuItem, "discountedPrice") > 0 && (
              <div className="discount-price">
                <NumericFormat
                  value={getPrice(selectedSkuItem, "price")}
                  displayType="text"
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
                <span className="discount-percent-off">
                  {getPrice(selectedSkuItem, "discountType") === "absolute"
                    ? currencySign +
                      getPrice(selectedSkuItem, "discountPercent")
                    : getPrice(selectedSkuItem, "discountPercent") + "%"}{" "}
                  {staticTexts.percentOff}
                </span>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {isItemOutOfStock && (
        <div className="out-of-stock-section --mobile">
          <span className="out-of-stock-msg">{staticTexts.outOfStockErr}</span>
          <div className="back-in-stock">
            <a
              className="gbh-data-layer"
              data-gbh-data-layer={getEventInfo(
                staticTexts.backInStock.toLowerCase(),
                false,
                pdpUrl?.trim().toLowerCase()
              )}
              data-gbh-data-layer-custom={productInfo}
              href={pdpUrl}
            >
              {staticTexts.backInStock}
            </a>
          </div>
        </div>
      )}
    </div>
  )
}

export default PDPRequiredItem
